<template>
  <div class="more-style">
    <p class="title-item-info">链接</p>
    <link-selector v-model="$$FormData.to_link" />
  </div>
</template>

<script>
export default {
  name: "customLink"
}
</script>

<style lang="scss" scoped>
.more-style {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 16px;
  box-sizing: border-box;
  line-height: normal;
  .title-item-info {
    margin-right: 16px;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }
}
</style>